import posthog from 'posthog-js'

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_API_HOST || 'https://us.i.posthog.com'

let initialized = false

export const initPostHog = () => {
  if (!POSTHOG_KEY || initialized) return

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: false,
    capture_pageleave: false,
    person_profiles: 'identified_only',
  })

  initialized = true
}

export const capturePostHogEvent = (eventName, properties = {}) => {
  if (!initialized) return
  posthog.capture(eventName, properties)
}

export const capturePostHogPageview = (pathname) => {
  if (!initialized) return

  posthog.capture('$pageview', {
    $current_url: `${window.location.origin}${pathname}`,
    pathname,
  })
}

export const identifyPostHogUser = (distinctId, properties = {}) => {
  if (!initialized || !distinctId) return
  posthog.identify(String(distinctId), properties)
}

export const resetPostHog = () => {
  if (!initialized) return
  posthog.reset()
}
